import React from 'react'

import Base from '../_Base'

const New = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M15.48 8.207a1 1 0 0 1 .397.397l1.951 3.568 3.568 1.95a1 1 0 0 1 0 1.755l-3.568 1.951-1.95 3.568a1 1 0 0 1-1.755 0l-1.951-3.568-3.568-1.95a1 1 0 0 1 0-1.755l3.568-1.951 1.95-3.568a1 1 0 0 1 1.358-.397zM15 11.168l-1.355 2.477L11.168 15l2.477 1.355L15 18.832l1.355-2.477L18.832 15l-2.477-1.355L15 11.168zM7.48 2.207a1 1 0 0 1 .397.397L9.121 4.88l2.275 1.244a1 1 0 0 1 0 1.754L9.12 9.121l-1.244 2.275a1 1 0 0 1-1.754 0L4.879 9.12 2.604 7.877a1 1 0 0 1 0-1.754L4.88 4.879l1.244-2.275a1 1 0 0 1 1.357-.397zM7 5 5 7l2 2 2-2-2-2z"
      fillRule="evenodd"
    />
  </Base>
)

export default New
